import { global } from ":shared/app";
import { ENDPOINTS } from "./endpoints";

export async function get_agenda() {
  return global.api
    .getAuth(ENDPOINTS.get_agenda)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      // message: service.api.decode_error(err, "couldn't update password"),
      return Promise.reject(err.message);
    });
}
